import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown font-sans-serif position-static" }
const _hoisted_2 = ["id", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ellipsis-h fs--1" }, null, -1)
const _hoisted_4 = ["aria-labelledby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-falcon-default btn-sm text-600 dropdown-toggle btn-reveal",
      type: "button",
      id: `btn-dropdown-${_ctx.id}`,
      "data-bs-toggle": "dropdown",
      "data-bs-boundary": "window",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      disabled: _ctx.disabled
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_3
      ])
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: "dropdown-menu dropdown-menu-right border py-2",
      "aria-labelledby": `btn-dropdown-${_ctx.id}`
    }, [
      _renderSlot(_ctx.$slots, "options")
    ], 8, _hoisted_4)
  ]))
}